import React from "react";
import { Progress } from "reactstrap";
import { WizardStep } from "../constants";

interface StepArrowNavProps {
  steps: Array<WizardStep & { clickable?: boolean }>;
  current: number;
  onStepClick?: (index: number) => void;
}

const StepArrowNav = ({ steps, current, onStepClick }: StepArrowNavProps) => {
  const total = steps.length || 1;
  const stepValue = 100 / total;
  return (
    <div className="step-arrow-nav mb-3">
      <Progress multi className="progress-step-arrow progress-success step-arrow-progress">
        {steps.map((step, index) => {
          const active = index === current;
          const done = index < current;
          const stateClass = active ? "is-active" : done ? "is-complete" : "is-pending";
          const canClick = Boolean(onStepClick) && (done || step.clickable);
          return (
            <Progress
              key={step.id}
              bar
              value={stepValue}
              color="light"
              className={`progress-step ${stateClass}`}
              striped={false}
              animated={false}
              onClick={() => {
                if (canClick && onStepClick) {
                  onStepClick(index);
                }
              }}
              style={{ cursor: canClick ? "pointer" : "default" }}
            >
              <div className="step-progress-label">
                <div className="step-title d-flex align-items-center">
                  <span>{step.navLabel ?? step.label}</span>
                  <span
                    className={`fw-semibold ${active ? "text-white" : "text-muted"} ms-1`}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {index + 1}
                  </span>
                </div>
                {step.navDescription ? <small>{step.navDescription}</small> : null}
              </div>
            </Progress>
          );
        })}
      </Progress>
    </div>
    
  );
};

export default StepArrowNav;
